'use client'

import Heading from '@/components/Heading/Heading'
import ContextualHelpModal from '@/components/Help/ContextualHelpModal'
import { useState } from 'react'
import OrderList from './OrderList'

export default function Home() {
    const [isHelpOpen, setIsHelpOpen] = useState(false)

    return (

    <div className="flex w-full bg-white gap-md min-h-full">
        <div className="flex-grow flex flex-col">
            <Heading
                title={'Orders'}
                description={'Manage and edit orders, update statuses, and oversee fulfillment efficiently.'}
                help={{
                    title: 'Help',
                    onClick: () => setIsHelpOpen(true),
                }}
                /*tab={{
                    onSelectedChange: handleOnSelectedTabChange,
                    selectedTab: selectedTab,
                    tabs: tabs,
                }}*/
            />
            <div className={'pr-xxl flex flex-col flex-grow'}>
                <OrderList/>
            </div>
        </div>
        <ContextualHelpModal categoryId="orders" isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
    </div>
    )
}
